<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-card >
                    <v-toolbar>
                        <v-toolbar-title>{{ title }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text >
                        <v-form @submit.prevent="save">
                            <v-text-field label="Name" variant="outlined" v-model="name" ></v-text-field>
                            <quill-editor theme="snow" toolbar="essential" style="height: 400px" v-model:content="description" contentType="html"></quill-editor>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn variant="elevated" class="ml-2 mr-3" @click="$router.push('/companies')" >Back</v-btn>
                        <v-btn variant="elevated" color="primary" class="mr-3" @click="save" >Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
                <v-card >
                    <v-toolbar>
                        <v-toolbar-title>Locations</v-toolbar-title>
                        <v-btn variant="elevated" color="primary" class="ml-2 mr-3" @click="showSearchBox" >Add</v-btn>
                    </v-toolbar>
                    <v-container :hidden="!showSearchLocation">
                        <v-row class="justify-space-between" >
                            <v-col class="pa-2" lg="6" xl="7">
                                <location-combo-box label="Search Location" variant="outlined" clearable item-title="name"
                                            item-value="locationId"
                                            v-model="location" ></location-combo-box>
                            </v-col>
                            <v-col class="pa-2" cols="auto" >
                                <v-btn variant="elevated" class="mr-3" @click="hideSearchBox" >Cancel</v-btn>
                                <v-btn variant="elevated" color="primary" class="mr-3" @click="assignLocation" >Save</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-list>
                        <v-list-item v-for="location in locations"
                            :key="location.locationId"
                            class="py-3">
                            <v-list-item-title>{{ location.name }}</v-list-item-title>
                            <template v-slot:append>
                                <v-btn
                                    color="grey-lighten-1"
                                    icon="mdi-delete"
                                    variant="text"
                                    @click="deleteEnity(location.locationId, location.name)"
                                ></v-btn>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Unassigne Location">
            <v-card-text>Are you sure you whant to unassigne location {{ locationName }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>


<script>
import CompanyApi from '../services/CompanyApi'
import LocationApi from '@/services/LocationApi';
import LocationComboBox from '@/components/LocationComboBox.vue';

export default {
    name: "CompanyEdit",
    data() {
        return {
            id: 0,
            name: "",
            description: "",
            showSearchLocation: false,
            location: null,
            title: "",
            locations: [],
            message: "",
            snackbar: false,
            timeout: 2000,
            dialogOn: false,
            locationName: "",
            locationId: 0
        }
    },
    components: {
        LocationComboBox
    },
    mounted() {
        var id = this.$route.params.id;
        this.id = id;
        if(!isNaN(id)) {
            this.title = "Edit";
            CompanyApi.get(id).then((response) => { 
                if(response && response.data) {
                   this.name = response.data.name
                   this.description = response.data.description
                   this.locations = response.data.locations
                }
            })
        }
        else {
            this.title = "Create";
        }
    },
    methods: {
        save() {
            let company = { 
                companyId: this.id, 
                name: this.name, 
                description: this.description,
                locations: this.locations
            }
            if(company.companyId > 0) {
                CompanyApi.put(this.id, company).then((response) => { 
                    this.message = response.data.state.message;
                    this.snackbar = true;
                })
            }
            else {
                CompanyApi.post(company).then((response) => { 
                    if(response && response.data) {
                        this.id = response.data.companyId;
                        this.$router.push('/companies/' + this.id);
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                })
            }
        },
        showSearchBox() {
            this.showSearchLocation = true;
        },
        hideSearchBox() {
            this.showSearchLocation = false;
        },
        assignLocation() {
            if(this.location == null || this.location?.locationId == null) {
                this.message = 'Pleas select a location first!';
                this.snackbar = true;
                return;
            }
            
            let item = this.locations.find((a) => a.locationId == this.location?.locationId);
            
            if(item) {
                this.message = 'Location already present in the list!';
                this.snackbar = true;
                return;
            }
            LocationApi.get(this.location?.locationId).then((response) => {
                if(response && response.data) {
                    this.locations.push({ locationId: response.data.locationId, name: response.data.name });
                    this.hideSearchBox();
                    this.location = null;
                    this.save()
                }
            })
            
        },
        deleteEnity(id, code) {
            this.locationId = id;
            this.locationName = code;
            this.dialogOn = true;
        },
        confirmDelete() {
            var index = this.locations.map(e => e.locationId).indexOf(this.locationId);
            if(index != -1) {
                this.locations.splice(index, 1);
                this.dialogOn = false;
                this.save();
            }
        }
    }
}
</script>